"use client";

export const setQueryParameter = (name: string, value: string) => {
  const newUrl = new URL(window.location.href);
  const newParams = new URLSearchParams(newUrl.searchParams);
  newParams.set(name, value);
  newUrl.search = newParams.toString();

  window.history.pushState({}, "", newUrl.toString());
};

export const updateQueryParameters = (param: {
  set?: Map<string, string>;
  delete?: string[];
}) => {
  const newUrl = new URL(window.location.href);
  const newParams = new URLSearchParams(newUrl.searchParams);

  // Apply set operations
  param?.set?.forEach((value, key) => {
    newParams.set(key, value);
  });

  // Apply delete operations
  param?.delete?.forEach((key) => {
    newParams.delete(key);
  });

  newUrl.search = newParams.toString();
  window.history.pushState({}, "", newUrl.toString());
};
